import { Job, SupabaseJob } from '@applicator/shared'

import { getStatusDisplay } from '../utils'

export function renderPositionColumn(
  job: Job,
  index: number,
  jobs: Job[],
  supabaseJobs: SupabaseJob[]
) {
  const originalIndex = job.id ? jobs.findIndex((j) => j.id === job.id) : -1
  const safeOriginalIndex = originalIndex >= 0 ? originalIndex : index
  const jobId = job.id || safeOriginalIndex.toString()
  const supabaseJob = supabaseJobs.find(j => j.id === jobId)
  const isRelevant = supabaseJob?.relevance_verdict === 'Fit'
  const isNotRelevant = supabaseJob?.relevance_verdict === 'No Fit'
  
  return (
    <span 
      className={`block truncate text-sm text-text-primary ${
        isRelevant ? 'hover:bg-brand-primary-subtle/75' : 
        isNotRelevant ? 'hover:bg-danger-subtle/75' : 
        'hover:bg-surface-subtle'
      }`}
    >
      {job.position}
    </span>
  )
}

export function renderCompanyColumn(
  job: Job,
  index: number,
  jobs: Job[],
  supabaseJobs: SupabaseJob[]
) {
  const originalIndex = job.id ? jobs.findIndex((j) => j.id === job.id) : -1
  const safeOriginalIndex = originalIndex >= 0 ? originalIndex : index
  const jobId = job.id || safeOriginalIndex.toString()
  const supabaseJob = supabaseJobs.find(j => j.id === jobId)
  const isRelevant = supabaseJob?.relevance_verdict === 'Fit'
  const isNotRelevant = supabaseJob?.relevance_verdict === 'No Fit'
  
  return (
    <span 
      className={`block truncate text-sm text-text-primary ${
        isRelevant ? 'hover:bg-brand-primary-subtle/75' : 
        isNotRelevant ? 'hover:bg-danger-subtle/75' : 
        'hover:bg-surface-subtle'
      }`}
    >
      {job.company}
    </span>
  )
}

export function renderStatusColumn(job: Job) {
  return <span className="text-sm text-text-primary">{getStatusDisplay(job.status)}</span>
}

export function renderScoreColumn(
  job: Job,
  index: number,
  jobs: Job[],
  supabaseJobs: SupabaseJob[]
) {
  const originalIndex = job.id ? jobs.findIndex((j) => j.id === job.id) : -1
  const safeOriginalIndex = originalIndex >= 0 ? originalIndex : index
  const jobId = job.id || safeOriginalIndex.toString()
  const supabaseJob = supabaseJobs.find(j => j.id === jobId)
  return (
    <span className="text-sm text-text-primary">
      {supabaseJob?.relevance_score !== null && supabaseJob?.relevance_score !== undefined 
        ? supabaseJob.relevance_score 
        : '-'}
    </span>
  )
}

export function renderVerdictColumn(
  job: Job,
  index: number,
  jobs: Job[],
  supabaseJobs: SupabaseJob[]
) {
  const originalIndex = job.id ? jobs.findIndex((j) => j.id === job.id) : -1
  const safeOriginalIndex = originalIndex >= 0 ? originalIndex : index
  const jobId = job.id || safeOriginalIndex.toString()
  const supabaseJob = supabaseJobs.find(j => j.id === jobId)
  if (supabaseJob?.relevance_verdict === 'Fit') {
    return <span className="text-sm text-brand-primary-strong font-medium">Fit</span>
  } else if (supabaseJob?.relevance_verdict === 'No Fit') {
    return <span className="text-sm text-danger-strong font-medium">No Fit</span>
  } else {
    return <span className="text-sm text-text-muted">-</span>
  }
}
